module.exports = __webpack_public_path__ + "static/media/yellowtail.c6e14853.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/yellowtail.jpg
// module id = 116
// module chunks = 0